import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateRegiao } from './can-activate-regiao';
import { RegiaoComponent } from './regiao.component';
import { RegiaoFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateRegiao],
                children: [
                    {path: '', component: RegiaoComponent},
                    {path: 'novo', component: RegiaoFormComponent},
                    {path: ':id', component: RegiaoFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateRegiao
    ]
})
export class RegiaoRoutingModule { }
